export const ERROR_CODES = {
  SESSION_EXPIRED: "Session expired, please login again.",
  INVALID_TOKEN: "Invalid token, please login again.",
  LOGIN_ORGANIZATION_REQUIRED: "Organization is required.",
  LOGIN_VERIFICATION_METHOD_REQUIRED: "Verification method is required.",
  INVALID_PHONE_NUMBER_OR_EMAIL: "Invalid Phone Number or Email.",
  ORGANIZATION_NOT_FOUND: "Organization not found. Please login again.",
};
